import { ReactElement } from 'react'
import logo from '../../assets/images/logo.svg'
import SignupStudent from '../../components/Auth/SignupStudent'
import { PageTitle, SkipLink } from '../../components/atoms'

export const pageTitle = 'Sign Up - Create your password'
export const idCreatePasswordPageMainContent = 'create-password-page-main-content'

function SignUp (): ReactElement {
  return (
    <div className='bg-black min-h-screen font-primary items-center flex justify-center'>
      <SkipLink targetId={idCreatePasswordPageMainContent} />

      <header className='absolute left-[40px] top-[40px]'>
        <img src={logo} className='w-[138px]' alt='logo' />
      </header>

      <main
        id={idCreatePasswordPageMainContent}
        tabIndex={-1}
      >
        <PageTitle title={pageTitle} />
        <section className='flex justify-center'>
          <SignupStudent />
        </section>
      </main>
      <footer className='sr-only' />
    </div>
  )
}

export default SignUp
